
export const minionMethods = [ 
                              'params',
                              'keys',
                              '___parent',
                              '___child',
                              '___children',
                              'constructor',
                              '___isClassOMat',
                              '___classGroup'
                            ];